import appConfig from '@/config/appConfig.typed';
import ageGateService from '@/services/ageGate/ageGateService';
import authService from '@/services/auth/authService';
import iccMarketService from '@/services/icc/iccMarketService';
import languageDataService from '@/services/localization/languageDataService';
import log from '@/services/logger/log';
import marketConfigService from '@/services/marketConfigService';
import appRouterService from '@/services/route/appRouterService';
import {selectGigyaToken, selectIsLoggedIn} from '@/state/selectors/auth';
import {selectIsConsumerDataFetched} from '@/state/selectors/consumer';
import {selectIsLoyaltyMember} from '@/state/selectors/consumerLoyalty';
import {selectIsAem} from '@/state/selectors/global';
import {getState} from '@/state/store';

const onAppStart = async () => {
    if (ageGateService.isAgeGateLocked()) {
        appRouterService.replaceToAgeGatePage();
        return;
    }

    if (ageGateService.isAgeGateRequired()) {
        appRouterService.replaceToAgeGatePage();
        return;
    }

    try {
        const state = getState();
        const isLoggedIn = selectIsLoggedIn(state);

        if (isLoggedIn) {
            await fetchConsumerData();

            if (appRouterService.isModalsPage()) {
                appRouterService.forwardToModalsPage();
            } else {
                const isAem = selectIsAem(state);

                if (isAem) {
                    appRouterService.forwardToTncPage();
                }
            }

            return;
        }

        if (marketConfigService.isInstallPwaEnabled()) {
            appRouterService.forwardToInstallPwaPage();

            return;
        }
    } catch (e) {
        log.info(`onAppStart: error: : ${JSON.stringify(e)}`);
    }

    appRouterService.forwardToLoginPage();
};

const fetchConsumerData = async () => {
    try {
        const state = getState();
        const isConsumerDataFetched = selectIsConsumerDataFetched(state);

        if (isConsumerDataFetched) return;

        const gigyaToken = selectGigyaToken(state);

        await iccMarketService.getExternalConsumerProfile(gigyaToken);
        await iccMarketService.getConsumerProfile();
        await iccMarketService.getConsumerAggregatedSettings();

        await languageDataService.checkAndSetConsumerLanguageCode();

        fetchLoyaltyJourneys();
    } catch (e) {
        authService.logout();
        throw e;
    }
};

const fetchLoyaltyJourneys = async () => {
    try {
        const gigyaToken = selectGigyaToken(getState());
        const isEnabled = gigyaToken && appConfig.getIsDcxLoyaltyEnabled();
        const isLoyaltyUser = selectIsLoyaltyMember(getState());

        if (!isEnabled || !isLoyaltyUser) return;

        await iccMarketService.getLoyaltyJourneys(gigyaToken);
    } catch (e) {
        log.info(`fetchLoyaltyJourneys: error: : ${JSON.stringify(e)}`);
    }
};

export default {
    onAppStart,
    fetchConsumerData,
    fetchLoyaltyJourneys,
};
